import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

/**
 * Banner component that displays when a new version is available
 */
const VersionUpdateBanner = ({ onRefresh, onDismiss, newVersion, currentVersion }) => {
  const theme = useSelector(state => state.theme);

  return (
    <div className={`version-update-banner ${theme.className}`}>
      <div className="version-update-banner__content">
        <div className="version-update-banner__icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 2v20M17 7l-5-5-5 5" />
          </svg>
        </div>
        <div className="version-update-banner__message">
          <strong>New Dashboard Version Available</strong>
          <span className="version-update-banner__details">
            {' '}
            Please do a hard refresh to get the latest updates.<br />
            {newVersion && currentVersion && (
              <span className="version-update-banner__version-info">
                {' '}
                (Current: {currentVersion}, New: {newVersion})
              </span>
            )}
          </span>
        </div>
        <div className="version-update-banner__actions">
          <button
            type="button"
            className="version-update-banner__button version-update-banner__button--primary"
            onClick={onRefresh}
          >
            Refresh Now
          </button>
          <button
            type="button"
            className="version-update-banner__button version-update-banner__button--secondary"
            onClick={onDismiss}
            aria-label="Dismiss"
          >
            Later
          </button>
        </div>
      </div>
    </div>
  );
};

VersionUpdateBanner.propTypes = {
  onRefresh: PropTypes.func.isRequired,
  onDismiss: PropTypes.func,
  newVersion: PropTypes.string,
  currentVersion: PropTypes.string,
};

VersionUpdateBanner.defaultProps = {
  onDismiss: null,
  newVersion: null,
  currentVersion: null,
};

export default VersionUpdateBanner;
